/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
    {
        path: "/login/:path?",
        name: "Login",
        view: "Login",
        role: ["admin"],
    },
    // {
    //     path: "/payments",
    //     name: "Payments",
    //     view: "Payments",
    //     role: ["admin"],
    // },
    {
        path: "/accounts",
        name: "Accounts",
        view: "Accounts",
    },
    // {
    //     path: "/properties",
    //     name: "Properties",
    //     view: "Properties",
    // },
    {
        path: "/transactions",
        name: "Transactions",
        view: "Transactions",
    },
    // {
    //     path: "/property:id",
    //     name: "Property",
    //     view: "Property",
    // },
    // {
    //     path: "/user-profile",
    //     name: "User Profile",
    //     view: "UserProfile"
    // },
    // {
    //     path: "/table-list",
    //     name: "Table List",
    //     view: "TableList"
    // },
    // {
    //     path: "/typography",
    //     view: "Typography"
    // },
    // {
    //     path: "/icons",
    //     view: "Icons"
    // },
    // {
    //     path: "/maps",
    //     view: "Maps"
    // },
    // {
    //     path: "/notifications",
    //     view: "Notifications"
    // },
];
